import { type ReactNode } from 'react';

export type LegalSection = {
  title: string;
  body: string;
};

const TITLE_CLS = 'mb-sm text-sm font-semibold text-text-primary';
const PARA_CLS = 'mb-sm text-sm leading-relaxed text-text-secondary last:mb-0';

function Paragraph({ text }: { text: string }): ReactNode {
  return <p className={PARA_CLS}>{text}</p>;
}

export function LegalSectionView({
  section,
}: {
  section: LegalSection;
}): ReactNode {
  const paragraphs = section.body.split('\n\n');
  return (
    <section className="mb-lg">
      <h3 className={TITLE_CLS}>{section.title}</h3>
      {paragraphs.map((p, i) => (
        <Paragraph key={i} text={p} />
      ))}
    </section>
  );
}
